import { toast } from 'sonner';

interface Props {
  autoCloseAfterSuccess?: boolean;
  callback?(): void;
  onClose?(): void;
  onOk?(): void;
  onSuccessOk?(): void;
  successMessage?: string;
  setLoading?(p: boolean): void;
}

export default function useAsyncCbOk({
  callback,
  onClose = () => null,
  onSuccessOk = () => null,
  onOk,
  successMessage,
  setLoading,
}: Props) {
  return callback
    ? async () => {
        setLoading?.(true);
        try {
          await callback();
          if (successMessage) {
            toast.success(successMessage);
          }
          onClose();
          onSuccessOk?.();
        } catch (error) {
          console.error(error);
        } finally {
          setLoading?.(false);
        }
      }
    : onOk;
}
